import {MarketingRepo} from '@core/repositories'
import config from "@core/config/app.config.js"
export default {
  getAccountsData (accountId){
    return MarketingRepo.get(`/show.json`)
  },
  saveAccountsData(accountId, config){
    return MarketingRepo.put(`/update.json`, config)
  },
  getIndustriesList(){
    return MarketingRepo.get(`/industries.json`,{
      baseURL: `${config.RAILS_BASE_URL}/v2`
    })
  },
  getCountriesList(){
    return MarketingRepo.get(`/countries.json`,{
      baseURL: `${config.RAILS_BASE_URL}/v2`
    })
  },
  getStatesList(countryCode){
    return MarketingRepo.get(`/countries/${countryCode}/states.json`,{
      baseURL: `${config.RAILS_BASE_URL}/v2`
    })
  },
  getOwnerData(accountId){
    return MarketingRepo.get(`/owner.json`)
  },
  /**
   * get sms volume stats
   * * @returns {Promise} total sms send and receive
   */
  getSmsUsage(accountId, data = {}) {
    const endpoint = `/sms_volume.json`;
    return MarketingRepo.get(endpoint, data);
  },
}